import { useEffect, useState } from "react";
import EmployeeLayout from "../components/EmployeeLayout";
import api from "../api";

const Holidays = () => {
  const [list, setList] = useState([]);
  const [loading, setLoading] = useState(false);

  const load = async () => {
    setLoading(true);
    try {
      const res = await api.get("/holidays");
      setList(res.data || []);
    } catch (err) {
      console.error("Error loading holidays", err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  return (
    <EmployeeLayout>
      <div className="emp-header">
        <div>
          <h1 className="emp-title">Holidays</h1>
          <p className="emp-subtitle">
            Company-declared holidays. Managed by admin.
          </p>
        </div>
      </div>

      <div className="card">
        {loading ? (
          <p>Loading...</p>
        ) : list.length === 0 ? (
          <p className="text-muted">No holidays available.</p>
        ) : (
          <div style={{ overflowX: "auto" }}>
            <table className="emp-table">
              <thead>
                <tr>
                  <th>Date</th>
                  <th>Name</th>
                  <th>Type</th>
                </tr>
              </thead>
              <tbody>
                {list.map((h) => (
                  <tr key={h.id}>
                    <td>{(h.holiday_date || "").slice(0, 10)}</td>
                    <td>{h.name}</td>
                    <td>{h.type}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </EmployeeLayout>
  );
};

export default Holidays;
